import { useState, useCallback } from "react";
import { MODAL_CLOSE_ANIMATION_DELAY } from "../configs/constants";
import type { Job } from "../types/jobs.types";

type UseJobModal = {
  isJobModalOpen: boolean
  currentJob: Job | null
  openJobModal: (job: Job) => Promise<void>
  closeJobModal: () => void
};

export const useJobModal = (): UseJobModal => {
  const [isJobModalOpen, setIsJobModalOpen] = useState(false);
  const [currentJob, setCurrentJob] = useState<Job | null>(null);

  const openJobModal = useCallback(async (job: Job): Promise<void> => {
    setCurrentJob(job);
    setIsJobModalOpen(true);
  }, []);

  const closeJobModal = useCallback(() => {
    setIsJobModalOpen(false);
    setTimeout(() => setCurrentJob(null), MODAL_CLOSE_ANIMATION_DELAY);
  }, []);

  return {
    isJobModalOpen,
    currentJob,
    openJobModal,
    closeJobModal,
  };
};
